// Microsoft Authentication Library (MSAL) configuration
export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_MICROSOFT_CLIENT_ID || '',
    authority: 'https://login.microsoftonline.com/common',
    // Redirect URI for OAuth callback - must match Azure AD app registration
    redirectUri: `${window.location.origin}/auth/callback/outlook`,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true, // Navigate back to original page after login
    clientCapabilities: ['CP1'] // Enable PKCE for authorization code flow
  },
  cache: {
    cacheLocation: 'sessionStorage', // Use sessionStorage for security
    storeAuthStateInCookie: false
  },
  system: {
    allowNativeBroker: false, // Disable for SPA
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000
  }
};

// OAuth exchange endpoint - server-side token exchange
export const oauthExchangeConfig = {
  // Edge function that exchanges auth code for tokens using client secret
  exchangeEndpoint: '/functions/v1/oauth-exchange',
};

// Add scopes for the Microsoft Graph API
export const loginRequest = {
  scopes: [
    'User.Read',
    'Calendars.Read',
    'Calendars.Read.Shared',
    'Calendars.ReadWrite', // Required for creating/updating/deleting calendar events
    'offline_access', // Required for refresh tokens
    'openid', // Required for authentication
    'profile' // Required for user profile info
  ],
  prompt: 'select_account'
};

// Graph API endpoint
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphCalendarEndpoint: 'https://graph.microsoft.com/v1.0/me/calendar/events'
};

// Calendar sync specific settings
export const calendarSyncConfig = {
  // Default sync range
  defaultSyncDays: 30,
  maxSyncDays: 90,
  
  // Event filtering
  excludeAllDayEvents: false, // All-day events are now handled properly (marked as full-day busy slots)
  excludeCancelledEvents: true,
  onlySyncBusyEvents: true,
  
  // Time range restrictions (golf hours)
  syncStartHour: 6, // 6 AM
  syncEndHour: 22,  // 10 PM
  
  // Sync frequency
  autoSyncIntervalHours: 24,
  
  // Event categories to sync
  syncEventCategories: ['busy', 'tentative', 'oof'] // out of office
};